import { graphql } from 'gatsby';
import React from 'react';
import NewLayout from '../components/new_layout';
import Seo from '../components/seo';
import MainSection50 from '../components/Layout/main-section-50';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import MainSection100 from '../components/Layout/main-section-100';
import ImageGroup from '../components/v2024/image/image-group';
import ReadyToTalk from '../components/v2023/ReadyToTalk/ready-to-talk';
import Tag from '../components/v2023/UI/Tag/tag';

const ComplianceHubV2 = ({ data, pageContext }) => {
    const page = data.page;
    const lang = pageContext.langKey

    return (
        <NewLayout pageContext={pageContext}>
            <Seo
                translates={pageContext.translates}
                title={page.seo.title}
                description={page.seo.description}
                image={page.seo.image_2}
            />

            <div className="main">
                {/* HERO */}
                <MainSection50
                    sectionType="color"
                    sectionColor="purple-dark"
                    sectionSize="lg"
                    childrenLeft={
                        <>
                            <Tag tag={page.hero_tag} />
                            <h1 className="hero">{page.hero_title}</h1>
                            <div className="container__text">
                                <ReactMarkdown children={page.hero_description} rehypePlugins={[rehypeRaw]} />
                            </div>
                        </>
                    }
                    childrenRight={
                        <GatsbyImage image={getImage(page.hero_image.localFile)} alt={page.hero_image.alternativeText} />
                    }
                />

                {/* INFORMATION */}
                {page.information_items.map((item, index) => {
                    return (
                        <MainSection50
                            sectionSize="md"
                            invert={index % 2 === 0}
                            childrenLeft={
                                <>
                                    <h2>{item.title}</h2>
                                    <div className="container__text">
                                        <ReactMarkdown children={item.description} rehypePlugins={[rehypeRaw]} />
                                    </div>
                                </>
                            }
                            childrenRight={
                                <GatsbyImage image={getImage(item.image.localFile)} alt={item.image.alternativeText} />
                            }
                        />
                    )
                })}

                {/* CHARACTERISTICS */}
                <MainSection100>
                    <div className='grid-lg-4'>
                        {page.characteristics.map((characteristic, index) => <ImageGroup basicInfoWithImage={characteristic} key={index} />)}
                    </div>
                </MainSection100>

                {/* Ready to Talk */}
                <MainSection100>
                <div className="ready-to-talk-simple">
                    <ReadyToTalk lang={lang} hideTags />
                </div>
            </MainSection100>
            </div>
        </NewLayout>
    );
};

export default ComplianceHubV2;

export const complianceQuery = graphql`
    query ($langKey: String) {
		page: strapi2026ComplianceHub (locale: { eq: $langKey }) {
			seo {
				title
				meta_description
				image_2 {
					localFile {
						publicURL
					}
				}
			}
            hero_tag {
                name
                type
            }
			hero_title
			hero_description
			hero_image {
				alternativeText
				localFile {
					childImageSharp {
						gatsbyImageData(
						    width: 656
						    breakpoints: [636, 520, 512, 350]
						    placeholder: BLURRED 
						    formats: [WEBP]
						)
					}
				}
			}
            information_items {
                title
                description
                image {
                    alternativeText
                    localFile {
                        childImageSharp {
                            gatsbyImageData(
                                width: 608
                                placeholder: BLURRED
                                formats: [WEBP]
                                breakpoints: [520, 512, 350]
                            )
                        }
                    }
                }
            }
            characteristics {
                title
                description
                image {
                    name
                    alternativeText
                    localFile {
                        childImageSharp {
                            gatsbyImageData(
                                width: 314
                                placeholder: BLURRED
                                formats: [WEBP]
                            )
                        }
                    }
                }
            }
		}
	}
`;
